import React, { useContext } from "react";
import { Button, Box, Typography } from '@mui/material';
import CartContext from "../../context/CartContext";
import { StoreContext } from "../../context/StoreContext";
import UserContext from "../../context/UserContext";
import ContactPopup from "../popup/ContactPopup";
import OrderPopup from "../popup/OrderPopup";
import { motion } from "motion/react"

const MotionButton = motion(Button);

const CheckOrder = () => {
  const minOrderAmount = 3000;
  const cartCtx = useContext(CartContext);
  const userCtx = useContext(UserContext);
  const totalItem = cartCtx.items.reduce((acc, cur) => acc + cur.qty, 0);


  const handlePageRoute = () => {
    if (totalItem === 0) {
      userCtx.showEmptyCartPopup();
      return;
    }

    if (totalItem > 0) {
      userCtx.goToOrderPage();
      return;
    }

    // exactly 1 item
    userCtx.goToOrderPage();
    setTimeout(() => {
      userCtx.showContactPopup();
    }, 500);
  };

  return (
    <Box sx={{ textAlign: 'center', marginTop: 6, marginBottom: 4 }}>
      <MotionButton
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        onClick={handlePageRoute}
        variant="contained"
        sx={{
          background: "linear-gradient(90deg, #FF2200 0%, #FF8C00 100%)",
          color: "white",
          borderRadius: "50px",
          fontWeight: "bold",
          textTransform: "uppercase",
          boxShadow: "0 6px 12px rgba(0, 0, 0, 0.3)",
          fontSize: {
            xs: "0.75rem",
            sm: "0.875rem",
            md: "1rem",
          },
          padding: {
            xs: "8px 16px",
            sm: "10px 20px",
            md: "16px 38px",
          },
        }}
      >
        PLEASE CHECK YOUR ORDER
      </MotionButton>
      <Typography
        variant="body2"
        sx={{
          color: 'red',
          marginTop: '22px',
          fontWeight: '600',
          fontFamily: '"Sora", sans-serif',
          fontSize: '16px',
        }}
      >
        Min. Order Amount  Rs. {minOrderAmount}
      </Typography>
      {/* <Typography
        variant="body2"
        sx={{
          mt: 0,
          fontWeight: 'bold',
        }}
      >
       Rs. {minOrderAmount}
      </Typography> */}
    </Box>
  );
};

export default CheckOrder;